import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "../components/table/dataTable";
import { hasRoles, getTokenExpired } from "../components/utils";
import PageLayout from "../components/layouts/pageLayout";
import Button from "../components/ui/button";

const StudentAdminPage = () => {
    const [studentModalTemplate, setStudentModalTemplate] = useState(1);
    const navigate = useNavigate();
    const studentTableRef = useRef(null);

    useEffect(() => {
        if (getTokenExpired()) return navigate("/login");

        const checkStudentRole = async () => {
            try {
                if (!hasRoles("Admin")) {
                    navigate("/no-access");
                }
            } catch (error) {
                console.error("Error checking roles:", error);
                navigate("/no-access");
            }
        };

        checkStudentRole();
    }, [navigate]);

    const onCreateStudent = async () => {
        setStudentModalTemplate(studentModalTemplate + 1);
        if (studentTableRef.current) {
            await studentTableRef.current.openModal("createStudent", []);
        }
    };

    return (
        <PageLayout title="Students">
            <DataTable tableId={2} ref={studentTableRef} actionButton={<Button variant="contained" onClick={onCreateStudent}>+ Create Student</Button>}
/>
        </PageLayout>
    );
};

export default StudentAdminPage;
